import { useMemo } from 'react';
import JlgLogoDesktop from './jlg-logo-desktop';
import JlgLogoMobile from './jlg-logo-mobile';
import PhoneIcon from '@/components/pi/navbar/phone-icon';

export type NavbarProps = {
  phone?: string;
  isScrolled?: boolean;
};

export function NavbarServer({ phone, isScrolled = false }: NavbarProps) {
  const onlyNumberPhone = useMemo(() => phone?.replace(/[^\d]/g, ''), [phone]);

  const ctaLink = phone
    ? `tel:+1${onlyNumberPhone}`
    : '#case-evaluation-form-lead.contact.first_name';

  return (
    <nav role="navigation" className="w-full bg-landing-background z-50 fixed top-0 left-0 right-0">
      <div
        className={`
          mx-auto flex w-full origin-top-right justify-between gap-4 
          max-w-7xl transition-all duration-400 ease-in-out
          items-end
          ${isScrolled ? 'max-h-[141px] md:max-h-[66px] lg:max-h-20' : 'max-h-[141px]'}
        `}
      >
        <div className="flex w-full items-end justify-start">
          <div
            className={`
              origin-bottom-left transition-all duration-400 ease-in-out
              pt-5 pb-4 pl-5
              md:py-5 md:pl-4
              lg:py-10 lg:pl-[35px]
              ${isScrolled ? 'md:scale-[0.8] lg:scale-[0.571429]' : ''}
            `}
          >
            <JlgLogoDesktop className="hidden md:block md:h-10 lg:h-15" />
            <JlgLogoMobile className="h-10 md:hidden" />
          </div>
        </div>

        <div
          className={`
            flex w-full justify-end items-end
            self-center
            ${isScrolled ? 'md:self-end' : ''}
          `}
        >
          <div
            className={`
              origin-bottom-right transition-all duration-400 ease-in-out
              py-[22px] pr-4
              lg:pr-[35px]
              ${isScrolled ? 'lg:py-[31px] md:scale-[0.8] lg:scale-[0.8]' : 'lg:py-[52px]'}
            `}
          >
            {phone && (
              <div className="hidden md:flex items-center gap-2">
                <PhoneIcon className="h-6.5 w-6.5 text-landing-primary" />
                <div className="text-landing-h1 text-landing-primary text-nowrap font-family-landing-body font-black text-[clamp(1.1rem,1.6vw,1.1rem)] md:text-[18px] hover:text-landing-primary-mid transition-colors duration-200 ease-in-out">
                  <span className="text-[clamp(.8rem, 1.5vw, .8rem)] md:text-[14px]">
                    FREE CONSULTATION
                  </span>
                  <br />
                  <a className="flex gap-2 items-center" href={ctaLink}>
                    {phone ?? 'Claim Now'}
                  </a>
                </div>
              </div>
            )}

            <a
              href={ctaLink}
              className={`bg-landing-primary hover:bg-landing-primary-mid rounded-full text-white px-7 py-2 font-black text-nowrap flex items-center justify-center gap-1.5 text-[14px] transition-colors duration-200 ease-in-out ${phone ? 'md:hidden' : 'md:text-base lg:text-[18px]'}`}
            >
              {phone && <PhoneIcon className="h-4 w-4" />}
              <span>{phone ? 'Call now' : 'Claim Now'}</span>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
export default NavbarServer;
